import { render } from "./ContentsTitle.vue?vue&type=template&id=38dca012"
import script from "./ContentsTitle.vue?vue&type=script&lang=js"
export * from "./ContentsTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__